import React from "react";
import SiteReviews from "../../Components/site-reviews/SiteReviews";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import QuestionBankCompPage from "../../Components/ExamPreparationCards/QuestionBankCompPage";
import FamousUniversity from "../../Components/ExamPreparationCards/FamousUniversity";
import HotCoursesHelp from "../../Components/ExamPreparationCards/HotCoursesHelp";
import Certificate from "../../Components/ExamPreparationCards/Certificate";
import BonusSection from "../../Components/BonusSection";
import StudentStories from "../../Components/StudentStories";
import ExamReadMoreSection from "../../Components/ExamReadMoreSection";
import CommonBanner from "../../Components/ExamPreparationCards/CommonBanner";
import Page from "../Metadata/Page";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";

const QuestionBank = () => {
  const subCategoryId = "67b58235fa3a63e9ddb92139";
  const categoryId = "677e07a9159c38853391c934";
   const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Question Bank"},
  ]
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
<div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>

      <CommonBanner subCategoryId={subCategoryId} />
      <SiteReviews />
      <QuestionBankCompPage />
      <HotCoursesHelp />
      <FamousUniversity />
      <Certificate />
      <BonusSection subCategoryId={subCategoryId} />
      <ExamReadMoreSection subCategoryId={subCategoryId} />
      <StudentStories />
      <ScrollTop />
    </>
  );
};

export default QuestionBank;
